<div style="position: relative">
  <div style="position: relative" (click)="dropdownClicked()">
    <input
      [placeholder]="'Search State'"
      [(ngModel)]="currentCountry.translatedName"
      class="country-input state-input"
      readonly
    />
    <img class="down-icon" src="./assets/images/downIcon.svg" />
  </div>
  <div *ngIf="dropdownToggle" class="dropdown">
    <input
      [placeholder]="'Search State'"
      [(ngModel)]="searchName"
      class="search-input"
    />
    <div id="scrolling_div" class="country-list">
      <div
        [ngClass]="
          currentCountry.translatedName == item.translatedName
            ? 'country-selected'
            : 'country-item'
        "
        (click)="selectCountry(item)"
        [id]="item.isoCode"
        class="country-item"
        *ngFor="let item of states | filter: searchName"
      >
        {{ item.translatedName }}
      </div>
    </div>
  </div>
</div>
